import "../modules/global.scss";
import React, { useState, useEffect } from "react";
import "./Pocetna.scss";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "../components/FormValidationsWarning.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import config from "../config.json";

function FizickoLiceLoginForm() {
  const { baseUrl, token } = config;
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");

  useEffect(() => {
    const cookies = new Cookies();
    const fizickoLice = cookies.get("fizickoLice");

    if (fizickoLice) {
      navigate("/login-fizickog-lica");
    }
  }, [navigate]);

  const onSubmit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/login-fizickog-lica`,
        values,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      const email = response.data.email;
      const korisnickoIme = response.data.korisnickoIme;
      const ime = response.data.ime;
      const telefon = response.data.telefon;

      const fizickoLice = { email, korisnickoIme, ime, telefon };

      const fizickoLiceString = JSON.stringify(fizickoLice);

      if (values.zapamtiMe) {
        const cookies = new Cookies(null, {
          path: "/",
          expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        });
        cookies.set("fizickoLice", fizickoLiceString, { path: "/" });
      } else {
        const cookies = new Cookies();
        cookies.set("fizickoLice", fizickoLiceString, { path: "/" });
      }
      setResponseMessage(response.data.message);
      navigate("/login-fizickog-lica");
    } catch (error) {
      setResponseMessage(error.response.data.message);
    }
    resetForm();
  };
  const { handleBlur, handleChange, handleSubmit, values, errors, touched } =
    useFormik({
      initialValues: {
        korisnickoIme: "",
        password: "",
        zapamtiMe: false,
      },
      onSubmit,
      validationSchema: Yup.object({
        korisnickoIme: Yup.string()
          .required("Niste unijeli ime.")
          .matches(
            /^[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*$/gi,
            "Ime ne može sadržavati brojeve."
          ),
        password: Yup.string()
          .required("Niste unijeli lozinku.")
          .min(8, "Lozinka mora sadržavati najmanje 8 znakova"),
      }),
    });

  return (
    <div>
      <div className="box-fizicko-lice"></div>
      <div className="box-fizicko-lice-text-naslov">FIZIČKO LICE</div>
      <div className="inputFieldsFizickoLice">
        <label id="labelKorisnickoimeFizickoLice" for="name">
          Korisničko ime
        </label>
        <form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSubmit();
            }
          }}
        >
          <input
            type="text"
            name="korisnickoIme"
            id="nameInputFizickoLice"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.korisnickoIme}
          />
          {touched.korisnickoIme && errors.korisnickoIme ? (
            <span className="input-error" id="nameInputFizickoLice-error">
              {errors.korisnickoIme}
            </span>
          ) : null}

          <label id="labelLozinkaFizickoLice" for="lozinkaFizickoLice">
            Lozinka
          </label>
          <input
            type="password"
            name="password"
            id="passwordInputFizickoLice"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
          {touched.password && errors.password ? (
            <span className="input-error" id="passwordInputFizickoLice-error">
              {errors.password}
            </span>
          ) : null}
        </form>
        <form onSubmit={handleSubmit}>
          <div>
            <label
              id="labelZapamtiMeFizickoLice"
              className="radioButtonLabelFizickoLice"
            >
              <input
                className="radioButtonFizickoLice"
                type="checkbox"
                value="option"
                name="zapamtiMe"
                onChange={handleChange}
                checked={values.zapamtiMe}
              />
              Zapamti me
            </label>
          </div>
          <Link
            to="/zaboravljen-password-fizicko-lice"
            id="forgottenPasswordLinkFizickoLice"
            className="forgottenPasswordLink"
          >
            Zaboravio/la si lozinku ?
          </Link>
          <Button
            type="submit"
            className="prijaviseButtonFizickoLice btn btn-primary btn-lg"
            variant="danger"
          >
            PRIJAVI SE
          </Button>
          <Link
            to="/registracija-fizickog-lica"
            id="noviKorisnikFizickoLice"
            className="forgottenPasswordLink"
          >
            Novi korisnik ? Registrujte se
          </Link>
        </form>
        <br></br>
        <b id="responseMessageFizickoLice">{responseMessage}</b>
      </div>
    </div>
  );
}

export default FizickoLiceLoginForm;
